export function accordion() {
// 全てのアコーディオンのトリガー（.j-accordion）とコンテンツ（.j-accordion-toggle）を取得
const accordions = document.querySelectorAll('.j-accordion');

accordions.forEach(accordion => {
  accordion.addEventListener('click', function() {
    // 対応するアコーディオンコンテンツ（次の兄弟要素）を取得
    const toggleContent = this.nextElementSibling;

    // アコーディオンコンテンツの表示・非表示を切り替え
    if (toggleContent.style.display === "block") {
      toggleContent.style.display = "none";
    } else {
      toggleContent.style.display = "block";
    }
  });
});

}



// .accordionクラスを持つ要素を全て取得し、forループで1つずつ処理。
// クリックイベントを追加し、クリックされた要素が.accordion-toggleクラスを持っているかどうかを確認。
// クリックされた.accordion-toggle要素の次の兄弟要素（.accordion-content）を取得。
// 取得した.accordion-content要素のmaxHeightスタイルが設定されている場合、nullに設定して閉じる。
// そうでない場合は、scrollHeightプロパティに設定された高さに設定して開く。